import React from 'react';
import { Check } from 'lucide-react';
import { Link } from 'react-router-dom';

const PricingCard = ({ 
  name, 
  price, 
  period = '', 
  description, 
  features, 
  popular = false,
  ctaText = "Get Started",
  ctaLink = "/contact",
  onCtaClick = null
}) => {
  return (
    <div className={`relative bg-white rounded-2xl overflow-hidden transition-all duration-500 hover:-translate-y-2 h-full flex flex-col ${
      popular 
        ? 'shadow-2xl border-2 border-blue-500 scale-105' 
        : 'shadow-lg hover:shadow-2xl border-2 border-slate-100'
    }`}>
      {/* Gradient overlay for popular */}
      {popular && (
        <div className="absolute top-0 left-0 right-0 h-2 bg-gradient-to-r from-blue-500 via-cyan-500 to-blue-500"></div>
      )}
      
      <div className="p-8 flex-grow flex flex-col">
        <div className="mb-6">
          <h3 className="text-2xl font-bold text-slate-900 mb-2">{name}</h3>
          {description && (
            <p className="text-slate-600 text-sm">{description}</p>
          )}
        </div>
        
        <div className="mb-6">
          <div className="flex items-baseline">
            <span className={`text-5xl font-extrabold ${popular ? 'text-blue-600' : 'text-slate-900'}`}>
              {price}
            </span>
            {period && <span className="text-slate-500 ml-2 text-sm">{period}</span>}
          </div>
        </div>
        
        <ul className="space-y-3 mb-8 flex-grow">
          {features.map((feature, index) => (
            <li key={index} className="flex items-start">
              <div className={`rounded-full p-0.5 mr-3 flex-shrink-0 mt-0.5 ${
                popular ? 'bg-blue-100' : 'bg-green-100'
              }`}>
                <Check className={`h-4 w-4 ${popular ? 'text-blue-600' : 'text-green-600'}`} />
              </div>
              <span className="text-slate-700 text-sm leading-relaxed">{feature}</span>
            </li>
          ))}
        </ul>
        
        {onCtaClick ? (
          <button
            onClick={onCtaClick}
            className={`block w-full text-center py-4 px-6 rounded-xl font-bold transition-all duration-300 transform hover:scale-105 ${
              popular
                ? 'bg-gradient-to-r from-blue-500 to-cyan-500 hover:from-blue-600 hover:to-cyan-600 text-white shadow-lg hover:shadow-xl'
                : 'bg-slate-900 hover:bg-slate-800 text-white'
            }`}
          >
            {ctaText}
          </button>
        ) : (
          <Link
            to={ctaLink}
            className={`block w-full text-center py-4 px-6 rounded-xl font-bold transition-all duration-300 transform hover:scale-105 ${
              popular
                ? 'bg-gradient-to-r from-blue-500 to-cyan-500 hover:from-blue-600 hover:to-cyan-600 text-white shadow-lg hover:shadow-xl'
                : 'bg-slate-900 hover:bg-slate-800 text-white'
            }`}
          >
            {ctaText}
          </Link>
        )}
      </div>
    </div>
  );
};

export default PricingCard;